module.exports = __webpack_public_path__ + "img/Group 7686.84d43a1c.svg";